/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

export const plainEnrolmentPath = "/a/v1/list/plain?entity=Enrolment";
export const plainPriorLearningPath = "/a/v1/list/plain?entity=PriorLearning";
export const plainOutcomePath = "/a/v1/list/plain?entity=Outcome";
export const plainCertificatePath = "/a/v1/list/plain?entity=Certificate";
export const plainPaymentInPath = "/a/v1/list/plain?entity=PaymentIn";
export const plainContactRelationTypePath = "/a/v1/list/plain?entity=ContactRelationType";
export const plainCorporatePassPath = "/a/v1/list/plain?entity=CorporatePass";
export const courseClassBudgetPath = "/a/v1/list/entity/courseClass/budget/";
export const courseClassTimetablePath = "/a/v1/list/entity/courseClass/timetable/";
export const courseClassCancelPath = "/a/v1/list/entity/courseClass/cancel";
export const fundingUploadsPath = "/a/v1/export/avetmiss8/uploads";